import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentUser: null
  },

  getters: {
    isSignedIn: state => !!state.currentUser,
    hasRole: state => role => state.currentUser && state.currentUser.roles.includes(role),
    hasFeatures: state => feature => state.currentUser && state.currentUser.features.includes(feature)
  },

  mutations: {
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser
      window.localStorage.setItem('currentUser', JSON.stringify(currentUser))
    },

    removeCurrentUser(state) {
      state.currentUser = null
      window.localStorage.removeItem('currentUser')
    }
  }
})

store.state.currentUser = JSON.parse(window.localStorage.getItem('currentUser'))

export default store
